import {SvgIcon} from 'components/SvgIcon';
import {Typography} from 'components/Typography';
import appStoreIcon from 'public/icons/app-store.svg';
import googlePlayIcon from 'public/icons/google-play.svg';

// import ruStoreIcon from 'public/icons/ru-store.svg';
import style from './style.module.scss';

const appLinksList = [
    {
        icon: <SvgIcon svg={appStoreIcon} />,
        path: 'https://apps.apple.com/us/app/karaca/id6741908644',
    },
    {
        icon: <SvgIcon svg={googlePlayIcon} />,
        path: 'https://play.google.com/store/apps/details?id=com.karaca.mobileapp',
    },
    // {
    //     icon: <SvgIcon svg={ruStoreIcon} />,
    //     path: '#',
    // },
];

export const MobileAppsSection = () => {
    return (
        <section className={style.root}>
            <div className={style.content}>
                <div className={style.contentLeft}>
                    <Typography className={style.title} color="gray100" element="h2" variant="h2">
                        В приложении ещё удобнее
                    </Typography>
                    <Typography className={style.description} color="gray80" element="p" variant="p">
                        Загрузите мобильное приложение по нужной кнопке ниже
                    </Typography>
                    <ul className={style.appList}>
                        {appLinksList.map(({icon, path}) => (
                            <li className={style.appItem} key={path}>
                                <a href={path} rel="noreferrer" target="_blank">
                                    {icon}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* <div className={style.qrCode}>
                    <img alt="qr code" src="/images/qr-code-app-store.png" />
                    <img alt="qr code" src="/images/qr-code-google-play.png" />
                </div> */}
                <div className={style.mobilePhone}>
                    <img alt="mobile phone" src="/images/mobile-phone.png" />
                </div>
            </div>
        </section>
    );
};
